import { matchPath } from 'react-router';
import type { MenuItem } from '@layout/Sidebar/MenuList/types';

function itemMatchesPath(item: MenuItem, pathname: string): boolean {
  if (
    item.handle?.activeOnPaths?.some((activePath) =>
      Boolean(matchPath({ path: activePath, end: false }, pathname)),
    )
  ) {
    return true;
  }

  return (
    Boolean(item.path) &&
    item.path.startsWith('/') &&
    !item.path.includes('*') &&
    Boolean(matchPath({ path: item.path, end: false }, pathname))
  );
}

export function hasMatchingNavigationChild(
  children: MenuItem[] | undefined,
  pathname: string,
): boolean {
  return (children ?? []).some(
    (child) =>
      itemMatchesPath(child, pathname) ||
      hasMatchingNavigationChild(child.children, pathname),
  );
}
